module.exports = __webpack_public_path__ + "d326fb544c7a032fbde8384e4afca006.svg";